export enum AddExistingMedicineFieldName {
  MedicineOrHealthSupplement = "medicineOrHealthSupplement",
  IntakeRegime = "intakeRegime",
  IntakePartOfDay = "usageDayPeriod",
}
